import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import { defaultFlags } from './default-flags';
import type { FeatureFlags } from './types';

export const getFeatureFlags = () => {
  return axios<FeatureFlags, BaseResponse<FeatureFlags>, void>({
    url: '/getValidFlags',
    method: 'get',
  });
};

export const useFeatureFlags = () => {
  // commented because there's a delay in updating the feature flags in the state hook so we are using the data directly which is faster
  // const [featureFlag, setFeatureFlags] = useState<FeatureFlags>(defaultFlags);

  const { data, isSuccess, isLoading } = useQuery({
    queryKey: ['feature-flags'],
    queryFn: () => getFeatureFlags(),
    useErrorBoundary: false,
    refetchOnWindowFocus: true,
    staleTime: 15 * 60 * 1000,
    retry: 3,
  });

  // useEffect(() => {
  //   const resultData = data?.data.data;
  //   if (resultData) {
  //     console.log(resultData);
  //     setFeatureFlags(resultData);
  //   } else {
  //     setFeatureFlags(defaultFlags);
  //   }
  // }, [data]);

  return {
    featureFlags: data?.data.data ? data?.data.data : defaultFlags,
    isFlagsFetched: isSuccess,
    isFetchingFeatures: isLoading,
  };
};
